import { render, staticRenderFns } from "./ROView.vue?vue&type=template&id=6037dd1a"
import script from "./ROView.vue?vue&type=script&lang=ts"
export * from "./ROView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports